import { Box, BoxProps } from '@amzn/ring-ui-react-components';

export const PostingDescription = (props: BoxProps) => (
  <Box
    as="p"
    color="neutral.500"
    mb={7}
    textStyle={{ base: 'body-normal-light', m: 'body-large-light' }}
    {...props}
  />
);
